import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { type ControllerRenderProps } from 'react-hook-form/dist/types/controller';

import { Control, type ControlOuterProps } from '@/components/common/Control';
import { DateInput, type DateInputProps } from '@/components/common/input/DateInput';

type FormDateInputProps = ControlOuterProps &
  Omit<DateInputProps, 'state' | keyof ControllerRenderProps> & {
    name: string;
  };

export const FormDateInput: FC<FormDateInputProps> = (props) => {
  const { name, label, className, ...dateInputProps } = props;

  return (
    <Controller
      name={name}
      render={({ field: { value, onChange, ...field }, fieldState }) => (
        <Control className={className} label={label} error={fieldState.error?.message}>
          <DateInput
            state={fieldState.invalid ? 'error' : 'default'}
            {...(dateInputProps as DateInputProps)}
            {...field}
            selected={value}
            onChange={(date: unknown) => {
              onChange(date ?? undefined);
            }}
          />
        </Control>
      )}
    />
  );
};
